import {
  Accordion as MuiAccordion,
  AccordionDetails as MuiAccordionDetails,
  AccordionSummary as MuiAccordionSummary,
} from '@mui/material';

import { SidePanelPropsTable } from '@/components/panels/instance/tabs/sidePanelPropsTable';
import { type FormattedField } from '@/components/table/hooks';

export const FieldsSection = ({
  fields,
  title,
  columnSpace,
  defaultExpanded,
}: {
  fields: FormattedField[];
  title: string;
  columnSpace?: 'small' | 'medium' | 'large';
  defaultExpanded?: boolean;
}) => {
  return (
    fields.length > 0 && (
      <MuiAccordion disableGutters defaultExpanded={defaultExpanded}>
        <MuiAccordionSummary data-testid='operation-summary'>
          {title}
        </MuiAccordionSummary>
        <MuiAccordionDetails sx={{ padding: '24px 0' }}>
          <SidePanelPropsTable withDividers columnSpace={columnSpace}>
            <tbody>
              {fields.map((field) => (
                <tr key={field.id}>
                  <td className='props-col'>{field.title}</td>
                  <td className='break-all'>{field.Component}</td>
                </tr>
              ))}
            </tbody>
          </SidePanelPropsTable>
        </MuiAccordionDetails>
      </MuiAccordion>
    )
  );
};
